export default "__VITE_ASSET__b0sedawy__"